<template>
  <Layout>
    <DataBox :loading="loading" :error="error">
      <PageTitle :from-query="fromQuery" />

      <div class="page-padding page-padding-all">
        <LogTable />

        <UiCard class="log-content">
          <div slot="content">
            <LogTrace />

            <LogContent />
          </div>
        </UiCard>
      </div>
    </DataBox>
  </Layout>
</template>

<script>
import Layout from '@/layout/inside/index.vue'

import LogTable from './LogTable.vue'
import DataBox from '@/components/DataBox.vue'
import LogTrace from './LogTrace.vue'
import LogContent from './LogContent.vue'
import UiCard from '@/components/card/UiCard.vue'

import { LogsService } from '@/services/logs.service'
import { redirectIfDenied } from '@/services/ability.service'

export default {
  page: {
    title: 'Логи',
  },
  components: {
    Layout,
    DataBox,
    PageTitle: () => import('./PageTitle.vue'),
    LogTable,
    LogContent,
    LogTrace,
    UiCard,
  },
  data() {
    return {
      loading: false,
      error: false,
      fromQuery: {},
    }
  },
  mounted() {
    this.getLogById()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromQuery = from.query
    })
  },
  destroyed() {
    this.$store.commit('logs/CLEAR_CURRENT_LOG')
  },
  methods: {
    /**
     * Send request to backend for get one Log by id.
     * Then run mutation `SET_CURRENT_LOG` in vuex.
     *
     * @returns {Object} data Response wrapper. Contains data of `Log`.
     * */
    async getLogById() {
      this.loading = true
      try {
        const logId = this.$route.params.id

        const { data } = await LogsService.getById({ logId })

        this.$store.commit('logs/SET_CURRENT_LOG', { ...data })
      } catch (error) {
        this.$store.commit('toast/NEW', { type: 'error', message: error.message })
        this.error = error.message

        redirectIfDenied.call(this, error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.log-content {
  padding-top: 0;
  >>> .card_content {
    padding: 0;
  }
}
</style>
